

import { Price } from "../../common/models/string-data.model";
import { ProposalAction, ProposalStatus, ProposalType } from "../constants/buy-basic-data";
import { ProposalModif } from "./proposal-modif.model";

export class Proposal {

    id = 0;
    type: ProposalType = ProposalType.BUY;

    proposerId = "";

    customerId = "";
    customerName = "";
    customerBusinessName = "";
    customerCountry = "";
    customerCity = "";

    providerId = "";
    providerName = "";
    providerBusinessName = "";
    providerCountry = "";
    providerCity = "";

    carId = "";
    carMake = "";
    carModel = "";
    carVersion = "";
    carYear: number  = 0;;
    carMileage: number = 0;

    offerId = "";
    offerTitle = "";
    offerDescription = "";
    offerPosted: boolean = false;
    offerClosed: boolean = false;
    offerStartDate = "";
    offerEndDate = "";
    offerPrice: Price= Price.getDefault();

    proposedPrice: Price= Price.getDefault();
    appointmentDate = "";
    comment = "";
    //rescheduleDate = "";
   status: ProposalStatus = ProposalStatus.SENT;

   completedPrice: Price= Price.getDefault();
   completedDate = "";
   completedNotes = "";

   created = "";
   lastUpdated = "";
   createdBy = "";
   lastUpdatedBy = "";

   actions: ProposalAction[] = [];
   modification?: ProposalModif = new ProposalModif();

     constructor(){
        this.offerPrice = Price.getDefault();
        this.proposedPrice = Price.getDefault();

        this.actions = []
     }
}

